<script lang="ts">
	import type { LuxAiApi } from "@lux-ai/api-interface"
	import { LuxAIController, setLuxAiController, type QuickActions } from "./LuxAIController.svelte"
	import { onDestroy, onMount } from "svelte"
	import Gallery from "./gallery/Gallery.svelte"
	import GenerateTheme from "./generate/Generate.svelte"
	import SnapshotSelect from "./snapshot/SnapshotSelect.svelte"
	import { Responsive } from "responsive"
	import { ProgressController, setProgressController } from "./ProgressHandler.svelte"
	import type { CurrentUserDataGetter, DeviceDataGetter } from "../types"

	interface Props {
		api: LuxAiApi
		quickActions: QuickActions
		userDataGetter: CurrentUserDataGetter
		deviceDataGetter: DeviceDataGetter
	}
	let {
		api,
		quickActions,
		userDataGetter: userDataFunctions,
		deviceDataGetter: deviceDataGetters,
	}: Props = $props()
	let progressController = new ProgressController()
	setProgressController(progressController)
	let controller = new LuxAIController(
		api,
		progressController,
		quickActions,
		userDataFunctions,
		deviceDataGetters,
	)
	setLuxAiController(controller)

	let view = $derived(controller.view)

	onMount(() => {
		controller.selectedCategory = undefined
	})

	onDestroy(() => {
		progressController.stopListening()
	})
</script>

<div class="lux-ai" class:mobile={Responsive.isMobile}>
	{#if view === "gallery"}
		<Gallery />
	{:else if view === "snapshot"}
		<SnapshotSelect />
	{:else if view === "generation"}
		<GenerateTheme />
	{/if}
</div>

<style>
	.lux-ai {
		height: 100%;
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.lux-ai :global(h1) {
		font-size: var(--h0);
		line-height: 1em;
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
	}

	.lux-ai :global(.heading) {
		text-align: start;
		width: 100%;
		justify-content: flex-start;
	}

	.lux-ai :global(.heading p) {
		line-height: 1.4em;
	}

	.lux-ai :global(.heading p) {
		line-height: 1.4em;
	}

	.lux-ai.mobile :global(.heading) {
		width: calc(100% - 1rem);
	}

	.lux-ai.mobile :global(h1) {
		font-size: var(--h1);
	}

	.lux-ai.mobile :global(.collection-title) {
		font-size: var(--h1);
	}

	.lux-ai.mobile :global(.heading p) {
		font-size: var(--h3);
	}
</style>
